import { ArrowLeft, Gamepad2, Clock, Sun, Box } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CustomCursor from "../components/CustomCursor";
import { Github, Globe } from "lucide-react";

const GameInterface = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white p-8">
      <CustomCursor />
      <Link 
        to="/" 
        className="inline-flex items-center text-yellow-300 hover:text-yellow-400 transition-colors mb-8"
      >
        <ArrowLeft className="mr-2 h-5 w-5" />
        Back to Portfolio
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto"
      >
        <h1 className="text-4xl font-bold mb-6 text-yellow-300">Interactive 3D Game Interface</h1>
        
        <div className="grid gap-8 md:grid-cols-2 mb-12">
          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Gamepad2 className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Unity Development</h3>
            </div>
            <p className="text-gray-300">
              Created an immersive 3D game interface using Unity, focusing on user engagement and realistic interactions.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Clock className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Real-time Features</h3>
            </div>
            <p className="text-gray-300">
              Integrated digital clocks and dynamic time-based features for enhanced realism.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Sun className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">Day-Night Cycle</h3>
            </div>
            <p className="text-gray-300">
              Implemented realistic day-night cycle simulations for environmental immersion.
            </p>
          </motion.div>

          <motion.div 
            className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm"
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-center mb-4">
              <Box className="h-6 w-6 text-yellow-300 mr-3" />
              <h3 className="text-xl font-semibold">3D Environment</h3>
            </div>
            <p className="text-gray-300">
              Designed and integrated dynamic 3D environments with smooth transitions and interactive elements.
            </p>
          </motion.div>
        </div>

        <div className="bg-gray-800/30 p-8 rounded-xl backdrop-blur-sm">
          <h2 className="text-2xl font-bold mb-4 text-yellow-300">Technical Stack</h2>
          <div className="flex flex-wrap gap-3">
            {["Unity", "3D Design", "C#", "Animation", "Lighting Systems", "Environmental Design"].map((tech) => (
              <span 
                key={tech}
                className="bg-yellow-300/10 text-yellow-300 px-3 py-1 rounded-full text-sm"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </motion.div>

      <div className="flex gap-4 mt-8 max-w-4xl mx-auto">
        <a
          href="https://github.com/healer3771/Interactive-3D-Game-Interface-Development"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-yellow-300 text-black px-4 py-2 rounded-lg hover:bg-yellow-400 transition-colors"
        >
          <Github className="h-5 w-5" />
          View on GitHub
        </a>
        <a
          href="https://game.qadeerahmad.work"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
        >
          <Globe className="h-5 w-5" />
          Live Demo
        </a>
      </div>
    </div>
  );
};

export default GameInterface;
